<script>
  import options from './PageControls.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <div class="be-page-controls">
      <p class="be-page-controls__text" aria-live="polite">{{ formatetLabel }}</p>
      <div v-if="totalSize > currentSize" class="be-page-controls__action">
          <button v-on:click="callback" class="be-btn be-btn--outline">{{ buttonLabel }}</button>
      </div>
  </div>
</template>
